export default {"src":"/_next/static/media/cortical-ventures-logo.3c204b24.svg","height":22,"width":239,"blurWidth":0,"blurHeight":0};